import useAuth from '../../hooks/useAuth';
import { axiosAuthInstance } from '../axios';

export async function login(username, password) {
  const data = {
    username,
    password,
  };
  const response = await axiosAuthInstance.post('/user/login', JSON.stringify(data));
  return response;
}

export async function mfaVerify(username, mfaVerificationCode, signUpToken) {
  const response = await axiosAuthInstance.post('/user/login/verifyMfa', { username, mfaVerificationCode }, {
    headers: {
      Authorization: `Bearer ${signUpToken}`,
    },
  });
  return response;
}

export async function sendVerificationCode(username, phoneNumber, signUpToken) {
  const response = await axiosAuthInstance.post('/user/mfa/signup', JSON.stringify({
    username,
    phoneNumber,
  }), {
    headers: {
      Authorization: `Bearer ${signUpToken}`,
    },
  });
  return response;
}

export async function verifyMfaCode({
  mfaVerificationCode,
  signupToken,
  mfaMethod,
  username,
  phoneNumber,
}) {
  const response = await axiosAuthInstance.post('/user/mfa/signup/verify', {
    username,
    phoneNumber,
    mfaVerificationCode,
    mfaMethod,
  }, {
    headers: {
      Authorization: `Bearer ${signupToken}`,
    },
  });
  return response;
}

export async function sendEmailMfaCode(signUpToken) {
  const response = await axiosAuthInstance.post('/user/mfaEmail/sendCode', undefined, {
    headers: {
      Authorization: `Bearer ${signUpToken}`,
    },
  });
  return response;
}

export function useRefreshTokens() {
  const { setAuth } = useAuth();

  const refresh = async () => {
    try {
      const response = await axiosAuthInstance.get('/user/refresh');
      setAuth((prev) => {
        const { accessToken } = response.data;
        return {
          ...prev,
          accessToken,
        };
      });
      return response.data;
    } catch {
      setAuth({});
      return null;
    }
  };
  return refresh;
}

export function useLogout() {
  const { setAuth, setPersist } = useAuth();
  const logout = async () => {
    await axiosAuthInstance.get('/user/logout');
    setPersist(false);
    setAuth({});
  };
  return logout;
}
